export const shouldShowDiscountDialog = ({ discount }) => {
  return discount ? discount.show : false;
};
